import { memo, useState } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import TitledHeadingText from "@coworker/apprestructured/src/task-management/components/TitledHeadingText/TitledHeadingText";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import {
  FixaOption,
  FixaSelect,
} from "@coworker/apprestructured/src/shared/wrappers/FixaSelect/FixaSelect";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";

function TitledHeadingTextDemo() {
  const [label, setLabel] = useState("Question");
  const [text, setText] = useState("How do I reset my password?");
  const [headingSize, setHeadingSize] = useState<"h1" | "h2" | "h3" | "h4">(
    "h2"
  );

  return (
    <Demo>
      <Name>TitledHeadingText</Name>
      <Highlight>
        <TitledHeadingText
          label={label}
          text={text}
          headingSize={headingSize}
        />
      </Highlight>
      <Actions>
        <FixaInputField
          label="label"
          type="text"
          id="titledheadingtextdemo-label"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
        />
        <FixaInputField
          label="text"
          type="text"
          id="titledheadingtextdemo-text"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <FixaSelect
          id="titledheadingtextdemo-headingsize"
          label="headingSize"
          value={headingSize}
          onChange={(e) =>
            setHeadingSize(e.target.value as "h1" | "h2" | "h3" | "h4")
          }
        >
          {(["h1", "h2", "h3", "h4"] as const).map((size) => (
            <FixaOption key={size} name={size} value={size} />
          ))}
        </FixaSelect>
      </Actions>
    </Demo>
  );
}

export default memo(TitledHeadingTextDemo);
